var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10,
    r: 9.5,
    fill: "#1A59C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26854 14.43C8.5519 14.43 8.76576 14.3124 8.92081 14.0825L13.9465 6.2445C14.0588 6.07341 14.1016 5.92371 14.1016 5.77935C14.1016 5.41044 13.845 5.15381 13.4707 5.15381C13.2087 5.15381 13.0537 5.2447 12.8933 5.49599L8.24715 12.8742L5.85192 9.79993C5.69687 9.59141 5.53647 9.50587 5.30122 9.50587C4.92697 9.50587 4.6543 9.7732 4.6543 10.1421C4.6543 10.3025 4.71311 10.4575 4.84677 10.6233L7.61626 14.0878C7.80339 14.3177 8.00121 14.43 8.26854 14.43Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPrimary);
export default __webpack_public_path__ + "static/media/confirm-primary.dd28c3a715c940dc4636df10c86908aa.svg";
export { ForwardRef as ReactComponent };